import {useContext} from 'react';

import {PopupSetter, PopupSetterContext} from '@/shared/providers/PopupProvider';

export const usePopupSetter = <T extends string>() => {
  return useContext(PopupSetterContext) as PopupSetter<T>;
};
